<template>
  <div>
    <div id="information">
      <div class="dispaybox">
        <div class="leftWrap">
          <div class="oneTit">
            <img src="../../assets/images/informationBig.png" alt="">
          </div>
          <div class="leftbox">
            <div v-for="(item,i) of tabList" :key="i" :class="i==tabIndex?'oneTitle active1 ':'oneTitle'" @click="changIndex(i)">
              {{ item.name }}
            </div>
            <div class="oneTitle" @click="logout()">退出登录</div>
          </div>
          <!-- <div class="logOut" @click="logout()">
            <span class="com">
              <span class="outSty">退出登录</span>
            </span>
          </div> -->
        </div>
        <div class="rightWrap">
          <!-- 表单内容 -->
          <myAddress v-if="tabIndex==0" />
          <loginPassword v-if="tabIndex==1" />
          <!-- <notice v-if="tabIndex==1" /> -->
        </div>
      </div>
    </div>

  </div>

</template>
<script>
/*global protocol http */
import { mapGetters } from 'vuex'
import myAddress from './informationTab/myAddress.vue'
// import notice from './informationTab/notice.vue'
import loginPassword from './informationTab/loginPassword.vue'
export default {
  components: {
    myAddress,
    // notice,
    loginPassword,

  },
  data() {
    return {
      sign: null,
      tabIndex: 0,
      tabList: [{ name: '我的地址' }, { name: '登录密码' }], // { name: '公告中心' },
    }
  },
  computed: {
    ...mapGetters(['sessionInfoGetter'])
  },
  mounted() {
    // this.getClasssfiyShop()
  },
  methods: {
    changIndex(i) {
      this.tabIndex = i
    },
    logout() {
      protocol.param_logout.param.userid = this.sessionInfoGetter.userId
      http.postFront(protocol.param_logout).then(response => {
        const { code } = response.data
        if (code == '0') {
          sessionStorage.clear()
          this.$store.commit('setSessionInfo', '')
          this.$store.commit('marketStatusInNewTopline', '--')
          this.$router.push('/')
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
#information{
    position: relative;
    // background: #292C3A;
    background: #ffffff;
    min-height: 100vh;
  .dispaybox{
    width:1200px;
    min-width: 1200px;
    background: #ffffff;
    margin:60px auto 0 auto;
    display: flex;
    justify-content: space-between;
    .leftWrap{
      width:200px;
      height:452px;
      background: #F4F4F4;
      border-radius: 10px;
      .oneTit{
        width:120px;
        height:120px;
        margin: 58px auto 50px auto;
        font-size: 20px;
        font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
        text-align: center;
        line-height: 120px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .leftbox{
        display: flex;
        width: 200px;
        flex-direction: column;
        align-content: space-between;
        justify-content: space-between;
        align-items: center;
        // margin-bottom: 42px;
        .oneTitle{
          cursor: pointer;
          width: 200px;
          box-sizing: border-box;
          height: 27px;
          text-align: center;
          border-left: 4px solid transparent;
          font-size: 20px;
          font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
          font-weight: 500;
          color: #333333;
          position: relative;

          height: 72px;
          line-height: 72px;
        }
        .active1{
          background: #1571DB;
          color: #FFFFFF;
          // border-left: 4px solid #E4CA91;
        }
      }
      .logOut{
        width: 200px;
        height: 42px;
        background: #636675;
        border-radius: 0px 0px 8px 8px;
        text-align: center;
        line-height: 42px;
        cursor: pointer;
        .outSty{
          font-size: 20px;
          font-family: Alibaba PuHuiTi-Regular, Alibaba PuHuiTi;
          font-weight: 400;
          color: #FCECC8;
        }
      }
    }
    .rightWrap{
      overflow: hidden;
      width:960px;
      height:auto;
      // background: #F4F4F4;
      border-radius: 10px;
      margin-bottom: 40px;
    }
  }
  .himgWrap{
    width:100vw;
    min-width: 1200px;
    height: 87px;
    background: #3B3E4E;
    .firstInfo{
      width: 1200px;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin:0 auto;
    }
     .oneTitle{
      font-size: 28px;
      font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
      font-weight: 500;
      color: #FFFFFF;
      position: relative;
      .imgInfo{
        position: absolute;
        width: 55px;
        left: calc(50% - 23px);
        top: -4px;
      }
     }
     .orderStore{
      display: flex;
      justify-content: flex-end;
      .searchWrap /deep/.el-input__inner{
        width: 240px;
        height: 34px;
        border-radius: 4px 0px 0px 4px;
        background:transparent;
        border: 1px solid #A5A6AC;
        font-size: 14px;
        font-family: Alibaba PuHuiTi-Regular, Alibaba PuHuiTi;
        font-weight: 400;
        color: #B6BDCC;
        box-sizing: border-box;
      }
      /deep/.el-input-group__append{
        width:60px;
        height: 35px;
        border:none;
        padding: 0;
        background: #A5A6AC;
        color:#fff;
        text-align: center;
        .el-icon-search{
          color:#fff;
        }
      }
      .btns{
        cursor: pointer;
        display: inline-block;
        width: 83px;
        height: 32px;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #D9D9D9;
        // box-sizing: border-box;
        text-align: center;
        font-size: 16px;
        font-family: Alibaba PuHuiTi-Regular, Alibaba PuHuiTi;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 33px;
        margin-left:16px;
      }
     }
  }
  .contentInfo{
    width:1200px;
    margin:0 auto;
    position: relative;
  }
  .storeList{
    min-height:670px;
    .itemStore{
      padding:30px 0;
      border-bottom: 2px solid #3B3E4E;
    }
    .storeInfo{
      .topStore{
        display: flex;
        align-items: center;
        .imgStore{
          width: 60px;
          height: 60px;
          border-radius: 43px 43px 43px 43px;
          margin-right: 13px;
        }
        .rightStore{
          width:calc(100% - 73px);
        }
        .flexSty{
          display: flex;
          align-items: center;
        }
        .flexBtSty{
          margin-top:10px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .name{
          font-size: 20px;
          font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
          font-weight: 500;
          color: #C99F62;
          line-height: 23px;
        }
        .constrc{
          margin-left:6px;
          width: 60px;
          height: 20px;
          background: #76634D;
          border-radius: 4px 4px 4px 4px;
          font-size: 12px;
          font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
          font-weight: 500;
          color: #DECAA2;
          line-height: 20px;
          text-align: center;
          cursor: pointer;
        }
      }
      .storeDesc{
        width:1000px;
        font-size: 12px;
        font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 14px;
        word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1; /* 这里是超出几行省略 */
        overflow: hidden;
      }
      .mores{
        width:100px;
        text-align: right;
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 14px;
        cursor: pointer;
        /deep/.el-icon-d-arrow-right{
          color:#fff;
        }
      }
    }
    // .goodInfo{
    //   width: 880px;
    // }
    .topGood{
      display: flex;
      justify-content: space-between;
      align-items: center;
      p{
        font-size: 18px;
        font-family: PingFang HK-Regular, PingFang HK;
        font-weight: 400;
        color: #FFFFFF;
        position: relative;
        cursor: pointer;
      }
      /deep/.el-icon-caret-top{
        position: absolute;
        font-size:16px;
        top: 0px;
        color: #FFFFFF;
      }
      /deep/.el-icon-caret-bottom{
        position: absolute;
        font-size:16px;
        bottom: 0px;
        color: #FFFFFF;
      }
      /deep/.el-icon-d-arrow-right{
        color:#fff;
      }
    }
    .goodList{
      display: flex;
      flex-wrap: wrap;
      position: relative;
      .goodStys{
        margin-right: 24px;
      }
      .maTop{
        margin-top:30px;
      }
      .goodItem{
        margin-top:22px;
        width: 180px;
        height: 260px;
        background: #3B3E4E;
        padding:10px;
        box-sizing: border-box;
        cursor: pointer;
      }
      .goodStys:nth-child(6n){
        margin-right: 0px;
      }
      .goodImg{
        width: 158px;
        height: 140px;
      }
      .name{
        margin-top:10px;
        height: 32px;
        // font-size: 16px;
        // font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
        // font-weight: 500;
        color: #FFFFFF;
        font-size: 14px;
        font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
        font-weight: 500;
        line-height: 16px;
        word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2; /* 这里是超出几行省略 */
        overflow: hidden;
      }
      .goodItem:hover {
        transform: translateY(-4px);
        transition-duration:1s;
        box-shadow: 2px 2px 2px 2px #171B2F;
        .name{
          color: #E4CA91;
        }
      }
      // .goodItem:hover img{
      //   transform: scale(0.8);
      // }
      // .name:hover{
      //   color: #C99F62;
      // }
      .marketPWrap{
        margin-top:14px;
        font-size: 14px;
        font-family: ITC Avant Garde Gothic Pro-Medium, ITC Avant Garde Gothic Pro;
        font-weight: 500;
        color: #9A9A9A;
        line-height: 19px;
        span{
          color: #9A9A9A;
          text-decoration: line-through;
        }
      }
      .priceWrap{
        margin-top:5px;
        font-size: 14px;
        font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
        font-weight: 500;
        color: #B0B8DB;
        line-height: 19px;
        i{
          font-style: normal;
          color:#9A9A9A;
        }
        .utils{
          font-size: 14px;
          font-family: ITC Avant Garde Gothic Pro-Demi, ITC Avant Garde Gothic Pro;
          font-weight: bold;
          color: #E4CA91;
          line-height: 19px;
        }
        .price{
          font-size: 20px;
          font-weight: bold;
          color: #E4CA91;
        }
      }
    }
    .twoStyleRow{
      height:30px;
      position: absolute;
      top: 280px;
      .iconWrap{
          /deep/.el-icon-arrow-left{
            font-size:26px;
            color:#fff;
            font-weight: bold;
            cursor: pointer;
            position: absolute;
            left: -30px;
            top:15px;
          }
          /deep/.el-icon-arrow-right{
            font-size:26px;
            color:#fff;
            font-weight: bold;
            cursor: pointer;
            position: absolute;
            right: -30px;
            top:15px;
          }
        }
      .bottomLine{
        width:880px;
        height: 2px;
        background: #3B3E4E;
        margin-top:28px;
      }
    }
  }
}
</style>

